import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CopyIcon } from './Icons';

const COPIED_FOR_MS = 2000;

/** A single code sample with a copy button. */
export function CodeBlock({ code, label }: { code: string; label: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => {
      setCopied(false);
    }, COPIED_FOR_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  return (
    <div className="code-panel code-block">
      <div className="code-bar">
        <span className="code-file">{label}</span>
        <button
          type="button"
          className="code-copy"
          onClick={() => {
            navigator.clipboard.writeText(code).then(
              () => {
                setCopied(true);
              },
              () => undefined,
            );
          }}
        >
          <CopyIcon />
          <span aria-live="polite">
            {copied ? t('landing.code.copied') : t('landing.code.copy')}
          </span>
        </button>
      </div>
      <pre tabIndex={0}>
        <code>{code}</code>
      </pre>
    </div>
  );
}
